import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=3f356f22&scoped=true&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadFile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UploadFile.vue?vue&type=style&index=1&id=3f356f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f356f22",
  null
  
)

export default component.exports